export function EmptyState({
  icon: Icon,
  title,
  description,
  action = null,
  className = "",
  compact = false,
}) {
  return (
    <div
      className={`suite-empty-state ${
        compact ? "suite-empty-state--compact" : ""
      } ${className}`.trim()}
    >
      {Icon && (
        <span className="suite-empty-icon">
          <Icon size={26} />
        </span>
      )}
      <h3>{title}</h3>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
